import React from 'react';

const Card = ({ 
  children, 
  title, 
  subtitle, 
  className = '', 
  noPadding = false,
  hoverable = true,
  action = null
}) => {
  const hoverClasses = hoverable 
    ? 'hover:shadow-xl dark:hover:shadow-gray-900/50 transition-all duration-300' 
    : '';
    
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-lg shadow-sm dark:shadow-gray-900/20 border border-gray-200 dark:border-gray-700 overflow-hidden ${hoverClasses} ${className}`}>
      {(title || subtitle || action) && (
        <div className="px-4 sm:px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/50 flex items-center justify-between">
          <div>
            {title && <h3 className="text-base sm:text-lg font-semibold text-gray-800 dark:text-gray-100">{title}</h3>}
            {subtitle && <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400 mt-1">{subtitle}</p>}
          </div>
          {action && <div>{action}</div>}
        </div>
      )}
      <div className={noPadding ? '' : 'p-4 sm:p-6'}>
        {children}
      </div>
    </div>
  );
};

export default Card;
